// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6a241c6e","455":"a8e6ac12"}[chunkId] + ".chunk.js";
};